<template>
	<div>
		<div v-if="!editShow">
			<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">预算管理</div>
			<el-row style="margin-top: 9px;">
				<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">
					<el-row>
						<!-- 左侧组织架构 -->
						<el-col :span="4" style="background-color: #f7f8fa; height: 750px;">
							<Structure ref="Structure" @parentFind="Find" :condition="condition"></Structure>
						</el-col>

						<!-- 右侧列表 -->
						<el-col :span="20">
							<el-row style="padding-left: 2%; padding-top: 40px;">
								<!-- <el-col :span="5">
									<span style="margin-left: 10px;">项目名称</span>
									<el-select v-model="condition.project_name" clearable style="width:150px"
										filterable>
										<el-option v-for="item in projectList" :key="item.id" :label="item.project_name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-col> -->

								<el-col :span="5">
									<span style="margin-left: 10px;">年度</span>
									<el-date-picker v-model="condition.annual" type="year" value-format="yyyy"
										style="margin-left:10px;width:150px">
									</el-date-picker>
								</el-col>

								<!-- <el-col :span="5">
									<el-input v-model="condition.estimate_collection_amount"
										style="margin-left:10px;width:220px" placeholder="请输入查询内容">
									</el-input>
								</el-col> -->

								<el-col :span="8">
									<el-button
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="Find">
										查询</el-button>
									<el-button
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="Add">
										导出</el-button>
									<!-- <el-button
										style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="Find">
										修改</el-button> -->
									<!-- <el-button
										style="width: 100px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
										@click="Find">
										提交审核111</el-button> -->
								</el-col>
							</el-row>

							<el-row style="margin: 0px 2%; margin-top: 20px;">
								<el-row>
									<el-table :header-cell-style="{ background: '#F0F0F0', color: '#000000' }"
										:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData"
										height="600" tooltip-effect="dark" style="width: 100%;"
										@selection-change="handleSelectionChange">
										<!-- <el-table-column type="selection" width="55">
										</el-table-column> -->
										<el-table-column align="center" label="序号" width="50">
											<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
										</el-table-column>
										<el-table-column prop="organizeName" align="center" label="架构" width="200">
										</el-table-column>
										<el-table-column prop="project_name" align="center" label="项目名称" width="200">
										</el-table-column>
										<el-table-column prop="annual" align="center" label="年度">
										</el-table-column>
										<el-table-column prop="annualExamine" align="center" width="120" label="年度编制状态">
											<template slot-scope="scope">
												<img src="../../../assets/budget/状态_编制中.png"
													v-if="scope.row.annualExamine == '1'" @click="annualExamine(scope.row)">
												<img src="../../../assets/budget/状态_审核中.png"
													v-if="scope.row.annualExamine == '2'" @click="annualExamine(scope.row)">
												<img src="../../../assets/budget/状态_已通过.png"
													v-if="scope.row.annualExamine == '3'" @click="annualExamine(scope.row)">
												<img src="../../../assets/budget/状态_已驳回.png"
													v-if="scope.row.annualExamine == '4'" @click="annualExamine(scope.row)">
											</template>
										</el-table-column>
										<el-table-column prop="monthlyExamine" align="center" width="120" label="月度审核状态">
											<template slot-scope="scope">
												<img src="../../../assets/budget/状态_未编制.png"
													v-if="scope.row.monthlyExamine == '1'"
													@click="monthlyExamine(scope.row)">
												<img src="../../../assets/budget/状态_审核中.png"
													v-if="scope.row.monthlyExamine == '2'"
													@click="monthlyExamine(scope.row)">
												<img src="../../../assets/budget/状态_已通过.png"
													v-if="scope.row.monthlyExamine == '3'"
													@click="monthlyExamine(scope.row)">
												<img src="../../../assets/budget/状态_已驳回.png"
													v-if="scope.row.monthlyExamine == '4'"
													@click="monthlyExamine(scope.row)">
											</template>
										</el-table-column>
										<el-table-column prop="accumulate_1" align="center" width="120" label="一月份总金额">
										</el-table-column>
										<el-table-column prop="accumulate_2" align="center" width="120" label="二月份总金额">
										</el-table-column>
										<el-table-column prop="accumulate_3" align="center" width="120" label="三月份总金额">
										</el-table-column>
										<el-table-column prop="accumulate_4" align="center" width="120" label="四月份总金额">
										</el-table-column>
										<el-table-column prop="accumulate_5" align="center" width="120" label="五月份总金额">
										</el-table-column>
										<el-table-column prop="accumulate_6" align="center" width="120" label="六月份总金额">
										</el-table-column>
										<el-table-column prop="accumulate_7" align="center" width="120" label="七月份总金额">
										</el-table-column>
										<el-table-column prop="accumulate_8" align="center" width="120" label="八月份总金额">
										</el-table-column>
										<el-table-column prop="accumulate_9" align="center" width="120" label="九月份总金额">
										</el-table-column>
										<el-table-column prop="accumulate_10" align="center" width="120" label="十月份总金额">
										</el-table-column>
										<el-table-column prop="accumulate_11" align="center" width="120" label="十一月份总金额">
										</el-table-column>
										<el-table-column prop="accumulate_12" align="center" width="120" label="十二月份总金额">
										</el-table-column>
										<el-table-column prop="estimate_collection_amount" align="center" label="编制人">
										</el-table-column>
										<el-table-column prop="renew_time" align="center" label="最后修改时间">
										</el-table-column>
										<el-table-column align="center" width="120" label="操作" fixed="right">
											<template slot-scope="scope">
												<img src="../../../assets/编辑.png" @click="Update(scope.row)">
												<img src="../../../assets/shenpi.png" @click="findOne(scope.row)">
											</template>
										</el-table-column>
									</el-table>
								</el-row>
								<el-row style="margin-top: 10px; text-align: center;">
									<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
										layout=" prev, pager, next, jumper" :total="total">
									</el-pagination>
								</el-row>
							</el-row>

						</el-col>
					</el-row>

				</div>
			</el-row>
			<el-dialog title="查看审批流程" :visible.sync="showPoint" width="25%" center="true" :close-on-click-modal="false">
				<div v-for="(item, index) in approveList" :key="index">
					<div class="approve">
						<div class="approve-left">
							<img src="../../../assets/oa/flowPath-green.png" alt="" class="approve-img"
								v-if="item.reviewer_state == 1">
							<img src="../../../assets/oa/flowPath-red.png" alt="" class="approve-img"
								v-if="item.reviewer_state == 2">
							<img src="../../../assets/oa/flowPath-orange.png" alt="" class="approve-img"
								v-if="item.reviewer_state == 0">
						</div>
						<div class="position">
							<div class="position-left">
								<div>{{ item.staff_name }}</div>
								<div
									:class="item.reviewer_state == 0 ? 'orange' : item.reviewer_state == 1 ? 'green' : item.reviewer_state == 2 ? 'red' : 'blue'">
									<span v-if="item.reviewer_state == 1">已同意</span>
									<span v-if="item.reviewer_state == 2">已驳回</span>
									<span v-if="item.reviewer_state == 0">待审批</span>
								</div>
								<div class="position-refuse" v-if="item.reviewer_state == 2">
									驳回原因：{{ item.reject_reason }}
								</div>
							</div>
							<div class="position-time" v-if="item.reviewer_state != 0">{{ item.reviewer_date }}</div>
						</div>
					</div>
					<div class="approve-hr" v-if="index != approveList.length - 1"></div>
				</div>
			</el-dialog>
		</div>
		<edit ref="edit" v-if="editShow" :ruleForm="ruleForm" :List="List" :title="title" @return="Return"></edit>

		<el-dialog title="审核" :visible.sync="spShow" width="35%" center="true" :close-on-click-modal="false">
			<div style="width: 100%;">
				<div>审核名称：预算审核</div>
				<el-table ref="multipleTable" :header-cell-style="{ background: '#F0F0F0', color: '#000000' }"
					:data="examineDetailsList" tooltip-effect="dark" style="width: 100%" height="300"
					@selection-change="handleSelectionChange">
					<el-table-column label="序号" width="50">
						<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
					</el-table-column>
					<el-table-column prop="node" label="节点" align="center">
					</el-table-column>
					<el-table-column prop="role_name" label="岗位" align="center">
					</el-table-column>
					<el-table-column prop="staff_name" label="审核人" align="center">
					</el-table-column>
				</el-table>
				<div style="text-align: center;margin-top: 10px;">
					<el-button type="goon" @click="findTwo()">确定</el-button>
				</div>
			</div>
			<div style="height: 30px;"></div>
		</el-dialog>

	</div>
</template>

<script>
import Structure from "../../utils/structure/structure.vue";
import edit from "./edit.vue";

import axios from "axios";
export default {
	components: {
		Structure: Structure,
		edit: edit,
	},
	data() {
		return {
			spShow: false,
			tableList: [],
			examineDetailsList: [],
			rowId:'',

			//列表相关
			total: 0,
			title: '',
			List: [],
			tableData: [],
			projectList: [],
			approveList: [],

			//页面相关
			editShow: false,
			ruleForm: {},

			//条件
			condition: {
				page_num: 1,
				page_size: 10,
				project_id: '',
				annual: '',
				project_name: '',
			},

			//复选框ids
			ids: [],
		};
	},
	methods: {
		async findOne(row) {
			this.rowId = row.id
			var data = await this.$globals.AxiosGet("budgetForm/getAnnualOaManageApproval?info=" + row.id);
			console.log(data);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				console.log(data);
				if (code === '200') {
					this.tableList = data
					this.examineDetailsList = data.examineDetailsList
					this.spShow = true
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}
		},
		async findTwo() {
			var data = await this.$globals.AxiosPost('budgetForm/annualApproval', {
				id: this.rowId,
				approval: this.tableList,
				applicant_id:this.$globals.user.staff_id
			});
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.message;
				console.log(data);
				if (code === '200') {
					this.$message.success(data);
					this.spShow = false
					this.Find()
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}
		},

		async annualExamine(e) {
			var record = {
				manage_id: e.id,
				approval_type: 17
			}
			var data = await this.$globals.AxiosPost('OaMaAssociation/getExamineDetails', record);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.approveList = data;
					if (this.approveList.length > 0) {
						this.showPoint = true;
					}
				} else {
					this.$message.warning(data);
				}
			}
		},
		async monthlyExamine(e) {
			var record = {
				manage_id: e.id,
				approval_type: 18
			}
			var data = await this.$globals.AxiosPost('OaMaAssociation/getExamineDetails', record);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.approveList = data;
					console.log(this.approveList.length)
					if (this.approveList.length > 0) {
						this.showPoint = true;
					}
				} else {
					this.$message.warning(data);
				}
			}
		},
		async Update(e) {
			this.List = e;
			// if (e.annualExamine == '1') {
			// 	this.title = '年度预算修改'
			// } else if (e.annualExamine == '3' && e.monthlyExamine == '1') {
			// 	this.title = '月度预算修改'
			// } else {
			// 	this.$message.warning('当前状态下不可修改！')
			// };

			var data = await this.$globals.AxiosGet('formSummary/detailsMap?info=' + e.id);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.ruleForm = data;
					this.total = data.total;
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}
			this.editShow = true;
		},
		Return() {
			this.editShow = false;
			this.Find();
		},

		//查询
		async Find() {
			var data = await this.$globals.AxiosPost('formSummary/getMap', this.condition);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.tableData = data.list;
					this.total = data.total;
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}
		},
		getNowTimeyear() {
			var date = new Date(),
				year = date.getFullYear();
			this.condition.annual = year.toString();
			console.log(this.condition.annual)
		},
		async getProjectList() {
			var res = await this.$globals.AxiosPost('AccountsInvoiceRegistration/getProjectList', {});
			this.ProjectList = res.data
		},
		//分页
		handleCurrentChange(val) {
			this.condition.page_num = val
			this.Find();
		},

	},
	async created() {
		this.getNowTimeyear();
		var projectList = await this.$globals.AxiosPost("tenderHonourAgreement/getProjectList", {});
		this.projectList = projectList.data;
		this.Find();

	}
}
</script>

<style scoped="scoped">
.el-button--goon:focus,
.el-button--goon:hover {
	background: #006e4b;
	border-color: #05573d;
}

.el-button--addbtn:focus,
.el-button--addbtn:hover {
	border-color: #05573d;
	color: #006e4b;
}

.el-button--goon {
	background-color: #006e4b;
	border-color: #006e4b;
	font-size: 15px;
	width: 85px;
}

.el-button--addbtn {
	color: #006e4b;
	border-color: #006e4b;
	font-size: 15px;
	width: 85px;
}

.el-table .warning-row {
	background: oldlace;
}

.el-table .success-row {
	background: #f0f9eb;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
	background-color: #006e4b;
	border-color: #006e4b;
}

.el-checkbox__input.is-focus .el-checkbox__inner {
	border-color: #006e4b;
}

.el-checkbox__inner:hover {
	border-color: #006e4b;
}

.el-button--pic {
	color: #006E4B;
	background-color: #fff;
	border-color: #006E4B;
	font-size: 10px;
	height: 30px;
	width: 70px;
	padding: 10px;
}

.el-button--pic:focus,
.el-button--pic:hover {
	background: #fff;
	border-color: #05573d;
	color: #006E4B;
}

>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #006E4B;
}

>>>.el-input__inner:focus {
	border-color: #006E4B;
}

>>>.el-select .el-input.is-focus .el-input__inner {
	border-color: #006E4B;
}

>>>.el-checkbox__input.is-checked .el-checkbox__inner,
>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #006E4B;
	border-color: #006E4B;
}

>>>.el-checkbox__inner:hover {
	border-color: #006E4B;
}

>>>.el-tree-node.is-expanded>.el-tree-node__children {
	display: inline;
}

.approve {
	display: flex;
}

.approve-left {
	width: 16%;
	text-align: right;
}

.approve-img {
	width: 50px;
	height: 50px;
}

.approve-hr {
	border-right: 2px solid #C7DCF0;
	height: 40px;
	width: 1px;
	margin-left: 10%;
	margin-top: -5px;
}

.position {
	display: flex;
	justify-content: space-between;
	width: 78%;
	margin-left: 5px;
}

.position-left {
	display: flex;
	flex-direction: column;
	justify-content: center;
	font-size: 16px;
	font-weight: 600;
	line-height: 24px;
}

.position-refuse {
	width: 205%;
	line-height: 30px;
	font-size: 12px;
	font-weight: 400;
	padding-left: 10px;
	background: #F9F9F9;
}

.position-text {
	font-size: 13px;
	margin: 0 10px;
	color: #C1C1C1;
}

.blue {
	color: #3295FA;
}

.green {
	color: #14BB83;
}

.orange {
	color: #FD892C;
}

.red {
	color: #F05745;
}

.position-time {
	font-size: 13px;
	color: #C1C1C1;
	line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// Budmanagement.vue?f564d306